import { render } from "./HelpCenter.vue?vue&type=template&id=422c79be&scoped=true"
import script from "./HelpCenter.vue?vue&type=script&lang=js"
export * from "./HelpCenter.vue?vue&type=script&lang=js"

import "./HelpCenter.vue?vue&type=style&index=0&id=422c79be&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-422c79be"]])

export default __exports__